import { TenantDTO } from 'probonio-shared-ui/api';
import { Trans } from 'react-i18next';
import { BenefitAttribute, BenefitColumnsExtensionInterface } from '../../../../extension/interface/benefit-columns.extension.interface';

export class CustomBenefitColumnsExtension extends BenefitColumnsExtensionInterface {
  getBenefitAttributes: (context?: { tenant?: TenantDTO }) => BenefitAttribute[] = context => [
    {
      id: 'customMonthlyGrant',
      accessorFn: value => value.customBenefitOptions?.monthlyGrant,
      header: 'CUSTOM.fields.monthlyGrant',
      renderer: value => (typeof value === 'number' ? <Trans i18nKey="common:money" values={{ money: value }} /> : null),
    },
    {
      id: 'customSupplier',
      accessorFn: value => value.customBenefitOptions?.supplier,
      header: 'CUSTOM.fields.supplier',
      renderer: value => {
        if (!(typeof value === 'string')) {
          return null;
        }
        return <div style={{ maxWidth: 150, overflowX: 'hidden', textOverflow: 'ellipsis' }}>{value}</div>;
      },
    },
    {
      id: 'customComment',
      accessorFn: value => value.customBenefitOptions?.comment,
      header: 'CUSTOM.fields.comment',
      renderer: value => {
        if (!(typeof value === 'string')) {
          return null;
        }
        return <div style={{ maxWidth: 150, overflowX: 'hidden', textOverflow: 'ellipsis' }}>{value}</div>;
      },
    },
  ];
}
